export default "__VITE_ASSET__31c75060__"